import {initWebHomeBannerCarousel} from "./home-banner-native";

$(document).ready(function() {
    initWebHomeBannerCarousel();
});
